module.exports = __webpack_public_path__ + "assets/img/incomplete-order.4031873a.png";